import { useSelector } from "react-redux";

export const Loader = () => {
  const isLoading = useSelector((state) => state?.globalReducer?.isLoading?.payload);
  return (
    isLoading === true && (
      <div className="loader-bg">
        <h3>Loading...</h3>
        <div className="loader">
          <span></span>
        </div>
      </div>
    )
  );
};
